import React, { useState } from 'react';
import { MdPhoneAndroid, MdClose } from 'react-icons/md';
import './phoneAppBanner.css';

/**
 * «حمّل نسخة الهاتف» — a bar at the bottom of cp when it is opened in an
 * Android phone's browser. The admin and الموجه get the panel app (cp as an
 * app, apps/cp_app); teachers get the staff app. Both APKs are uploaded by
 * deploy and served by api/src/routes/app.js. Hidden inside the app itself
 * (Android WebView) and for a day after the user closes it.
 */
const API = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8787';
const KEY = 'mtz.phoneAppBanner.closedAt';
const DAY = 24 * 60 * 60 * 1000;

function shouldShow() {
  if (typeof navigator === 'undefined' || !/Android/i.test(navigator.userAgent) || /; wv\)/.test(navigator.userAgent)) return false;
  try {
    return Date.now() - Number(localStorage.getItem(KEY) || 0) > DAY;
  } catch {
    return true;
  }
}

export default function PhoneAppBanner({ role }) {
  const [open, setOpen] = useState(shouldShow);
  if (!open) return null;
  const office = role === 'admin' || role === 'register';
  const href = `${API}/api/v1/app/download/${office ? 'panel' : 'staff'}`;
  const close = () => {
    try { localStorage.setItem(KEY, String(Date.now())); } catch { /* private mode */ }
    setOpen(false);
  };
  return (
    <div className="phone-app-banner" role="region" aria-label="تطبيق الهاتف">
      <MdPhoneAndroid className="phone-app-banner-icon" aria-hidden="true" />
      <div className="phone-app-banner-text">
        <strong>نسخة الهاتف</strong>
        <span>{office ? 'لوحة التحكم كتطبيق على هاتفك' : 'تطبيق الكادر: التفقّد والعلامات من هاتفك'}</span>
      </div>
      <a className="phone-app-banner-btn" href={href}>حمّل التطبيق</a>
      <button type="button" className="phone-app-banner-close" onClick={close} aria-label="إغلاق">
        <MdClose />
      </button>
    </div>
  );
}
